import styled from 'styled-components';

export const Container = styled.span`
    .ant-checkbox-wrapper {
        &:last-child {
            margin-right: 0;
        }
    }
`;
